export default __webpack_public_path__ + "static/media/nature.c866d607.jpg";